'use strict';

var seoCopy = require('./components/seoCopy');

$(document).ready(function() {
    seoCopy.readMoreListener('pd-seo-copy');
});
